import { render } from "./Resident.vue?vue&type=template&id=0d037a2f&scoped=true"
import script from "./Resident.vue?vue&type=script&lang=js"
export * from "./Resident.vue?vue&type=script&lang=js"

import "./Resident.vue?vue&type=style&index=0&id=0d037a2f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0d037a2f"

export default script